import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

// Restaure la liste des clients depuis le localStorage (déjà écrite par
// ADD_CLIENTS/ADD_CONTACTS à chaque chargement) : sans ça, state.contacts
// repart vide à chaque rechargement de page et le client sélectionné ne
// peut plus être retrouvé par son id (nom affiché, téléphone pour la fidélité...).
let restoredContacts = []
try {
    restoredContacts = JSON.parse(localStorage.contacts || '[]') || []
} catch (e) {
    restoredContacts = []
}

const initialState = {
    contacts: restoredContacts,
    clientId: null,
    countries: [],
    states: [],
    cities: [],
    streets: [],
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations,
}
